import { DateTime } from 'luxon';

export function getStatisticFormatedDate(currentDate: Date, format: string) {
  return DateTime.fromJSDate(currentDate).toFormat(format);
}
